import * as nodeParticleEditor from "node-particle-editor/legacy/legacy";
export { nodeParticleEditor };
export default nodeParticleEditor;
